document.addEventListener('DOMContentLoaded', function() {
  gsap.registerPlugin(ScrollTrigger);

  window.addEventListener('load', function() {
    document.body.classList.remove('loading');

    // Get all elements that need splitting
    const elementsToSplit = document.querySelectorAll('[data-splitting]');
    
    // Process each element based on its data-split-by attribute
    elementsToSplit.forEach(element => {
      const splitBy = element.getAttribute('data-split-by') || 'chars';
      Splitting({ target: element, by: splitBy });
    });

    const wrapElements = (elems, wrapType, wrapClass) => {
      elems.forEach(char => {
        const wrapEl = document.createElement(wrapType);
        wrapEl.classList = wrapClass;
        char.parentNode.appendChild(wrapEl);
        wrapEl.appendChild(char);
      });
    };

    // Helper function to get the elements to animate based on split type
    const getElementsToAnimate = (container) => {
      const splitBy = container.getAttribute('data-split-by') || 'chars';
      
      if (splitBy === 'chars') {
        return container.querySelectorAll('.char');
      } else if (splitBy === 'words') {
        return container.querySelectorAll('.word');
      } else if (splitBy === 'lines') {
        return container.querySelectorAll('.line');
      }
      
      // Default to chars if not specified or invalid
      return container.querySelectorAll('.char');
    };

    // Define all sets
    const fx1Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect1]')];
    const fx2Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect2]')];
    const fx3Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect3]')];
    const fx4Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect4]')];
    const fx5Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect5]')];
    const fx6Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect6]')];
    const fx7Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect7]')];
    const fx8Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect8]')];
    const fx9Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect9]')];
    const fx10Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect10]')];
    const fx11Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect11]')];
    const fx12Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect12]')];
    const fx13Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect13]')];
    const fx14Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect14]')];
    const fx15Titles = [...document.querySelectorAll('.content__title[data-splitting][data-effect15]')];

    // Scroll animations
    const scroll = () => {
      
      // Effect 1
      fx1Titles.forEach(title => {
        const elements = getElementsToAnimate(title);
        gsap.fromTo(elements,
          { opacity: 0, scale: 0.6, rotationZ: () => gsap.utils.random(-20, 20) },
          { 
            opacity: 1, 
            scale: 1, 
            rotationZ: 0, 
            stagger: 0.4, 
            ease: 'power4',
            scrollTrigger: {
              trigger: title,
              start: 'top 80%',
              end: 'top 10%',
              scrub: true
            }
          }
        );
      });

      // Effect 2
      fx2Titles.forEach(title => {
        const elements = getElementsToAnimate(title);
        gsap.fromTo(elements,
          { opacity: 0, yPercent: 120, scaleY: 2.3, scaleX: 0.7, transformOrigin: '50% 0%' },
          { 
            opacity: 1, 
            yPercent: 0, 
            scaleY: 1, 
            scaleX: 1, 
            stagger: 0.03,
            ease: 'back.inOut(2)',
            scrollTrigger: {
              trigger: title,
              start: 'top 80%',
              end: 'top 10%',
              scrub: true
            }
          }
        );
      });

      // Effect 3
      fx3Titles.forEach(title => {
        const elements = getElementsToAnimate(title);
        gsap.fromTo(elements,
          { scaleY: 0, transformOrigin: '50% 0%' },
          { 
            scaleY: 1, 
            yPercent: 0,
            stagger: 0.03,
            ease: 'back',
            scrollTrigger: {
              trigger: title,
              start: 'top 80%',
              end: 'top 10%',
              scrub: true
            }
          }
        );
      });

      // Effect 4
      fx4Titles.forEach(title => {
        const splitBy = title.getAttribute('data-split-by') || 'chars';
        
        if (splitBy === 'chars') {
          const words = title.querySelectorAll('.word');
          words.forEach(word => {
            const chars = word.querySelectorAll('.char');
            gsap.fromTo(chars,
              { x: (position, _, arr) => 150 * (position - arr.length / 2) },
              { 
                x: 0,
                stagger: { grid: 'auto', from: 'center' },
                ease: 'power1.inOut',
                scrollTrigger: {
                  trigger: word,
                  start: 'top 80%',
                  end: 'top 10%',
                  scrub: true
                }
              }
            );
          });
        } else {
          // For words or lines
          const elements = getElementsToAnimate(title);
          gsap.fromTo(elements,
            { x: (position, _, arr) => 150 * (position - arr.length / 2) },
            { 
              x: 0,
              stagger: { grid: 'auto', from: 'center' },
              ease: 'power1.inOut',
              scrollTrigger: {
                trigger: title,
                start: 'top 80%',
                end: 'top 10%',
                scrub: true
              }
            }
          );
        }
      });

      // Effect 5
      fx5Titles.forEach(title => {
        const elements = getElementsToAnimate(title);
        gsap.fromTo(elements,
          { opacity: 0, xPercent: () => gsap.utils.random(-200, 200), yPercent: () => gsap.utils.random(-150, 150) },
          { 
            opacity: 1,
            xPercent: 0,
            yPercent: 0,
            stagger: { each: 0.05, from: 'random' },
            ease: 'power1.inOut',
            scrollTrigger: {
              trigger: title,
              start: 'top 80%',
              end: 'top 10%',
              scrub: true
            }
          }
        );
      });

      // Effect 6
      fx6Titles.forEach(title => {
        const splitBy = title.getAttribute('data-split-by') || 'chars';
        
        if (splitBy === 'chars') {
          const words = title.querySelectorAll('.word');
          words.forEach(word => {
            const chars = word.querySelectorAll('.char');
            chars.forEach(char => gsap.set(char.parentNode, { perspective: 2000 }));
            gsap.fromTo(chars,
              { opacity: 0, rotationX: -90, yPercent: 50 },
              { 
                opacity: 1, 
                rotationX: 0, 
                yPercent: 0,
                stagger: { each: 0.03 },
                ease: 'power1.inOut',
                scrollTrigger: {
                  trigger: word,
                  start: 'top 80%',
                  end: 'top 10%',
                  scrub: true
                }
              }
            );
          });
        } else {
          // For words or lines
          const elements = getElementsToAnimate(title);
          elements.forEach(el => gsap.set(el.parentNode, { perspective: 2000 }));
          gsap.fromTo(elements,
            { opacity: 0, rotationX: -90, yPercent: 50 },
            { 
              opacity: 1, 
              rotationX: 0, 
              yPercent: 0,
              stagger: { each: 0.03 },
              ease: 'power1.inOut',
              scrollTrigger: {
                trigger: title,
                start: 'top 80%',
                end: 'top 10%',
                scrub: true
              }
            }
          );
        }
      });

      // Effect 7
      fx7Titles.forEach(title => {
        const splitBy = title.getAttribute('data-split-by') || 'chars';
        
        if (splitBy === 'chars') {
          const words = title.querySelectorAll('.word');
          words.forEach(word => {
            const chars = word.querySelectorAll('.char');
            chars.forEach(char => gsap.set(char.parentNode, { perspective: 2000 }));
            gsap.fromTo(chars,
              { transformOrigin: '100% 50%', opacity: 0, rotationY: -90, z: -300 },
              { 
                opacity: 1, 
                rotationY: 0, 
                z: 0,
                stagger: { each: 0.06, from: 'end' },
                ease: 'expo',
                scrollTrigger: {
                  trigger: word,
                  start: 'top 80%',
                  end: 'top 10%',
                  scrub: true
                }
              }
            );
          });
        } else {
          // For words or lines
          const elements = getElementsToAnimate(title);
          elements.forEach(el => gsap.set(el.parentNode, { perspective: 2000 }));
          gsap.fromTo(elements,
            { transformOrigin: '100% 50%', opacity: 0, rotationY: -90, z: -300 },
            { 
              opacity: 1, 
              rotationY: 0, 
              z: 0,
              stagger: { each: 0.06, from: 'end' },
              ease: 'expo',
              scrollTrigger: {
                trigger: title,
                start: 'top 80%',
                end: 'top 10%',
                scrub: true
              }
            }
          );
        }
      });

      // Effect 8 (random letters)
      const lettersAndSymbols = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','!','@','#','$','%','^','&','*','-','_','+','=',';',':','<','>',','];
      fx8Titles.forEach(title => {
        const splitBy = title.getAttribute('data-split-by') || 'chars';
        
        if (splitBy === 'chars') {
          const chars = title.querySelectorAll('.char');
          chars.forEach((char, i) => {
            const original = char.innerHTML;
            gsap.fromTo(char,
              { opacity: 0 },
              { 
                duration: 0.03,
                innerHTML: () => lettersAndSymbols[Math.floor(Math.random() * lettersAndSymbols.length)],
                repeat: 1,
                repeatRefresh: true,
                opacity: 1,
                repeatDelay: 0.03,
                delay: (i + 1) * 0.18,
                onComplete: () => gsap.set(char, { innerHTML: original }),
                scrollTrigger: {
                  trigger: title,
                  start: 'top bottom',
                  end: 'bottom center',
                  toggleActions: 'play none none reset',
                }
              }
            );
          });
        } else {
          // Fallback for words and lines - simple fade in
          const elements = getElementsToAnimate(title);
          gsap.fromTo(elements,
            { opacity: 0 },
            { 
              opacity: 1,
              stagger: 0.1,
              ease: 'power1.inOut',
              scrollTrigger: {
                trigger: title,
                start: 'top bottom',
                end: 'bottom center',
                toggleActions: 'play none none reset',
              }
            }
          );
        }
      });

      // Effect 9
      fx9Titles.forEach(title => {
        const splitBy = title.getAttribute('data-split-by') || 'chars';
        
        if (splitBy === 'chars') {
          const words = title.querySelectorAll('.word');
          words.forEach(word => {
            const chars = word.querySelectorAll('.char');
            gsap.fromTo(chars,
              { scaleX: 0, x: (_, target) => window.innerWidth / 2 - target.offsetLeft - target.offsetWidth / 2 },
              { 
                scaleX: 1,
                x: 0,
                ease: 'power1.inOut',
                scrollTrigger: {
                  trigger: word,
                  start: 'top 80%',
                  end: 'top 10%',
                  scrub: true
                }
              }
            );
          });
        } else {
          // For words or lines
          const elements = getElementsToAnimate(title);
          gsap.fromTo(elements,
            { scaleX: 0, x: (_, target) => window.innerWidth / 2 - target.offsetLeft - target.offsetWidth / 2 },
            { 
              scaleX: 1,
              x: 0,
              ease: 'power1.inOut',
              stagger: 0.05,
              scrollTrigger: {
                trigger: title,
                start: 'top 80%',
                end: 'top 10%',
                scrub: true
              }
            }
          );
        }
      });

      // Effect 10
      fx10Titles.forEach(title => {
        const elements = getElementsToAnimate(title);
        gsap.fromTo(elements,
          { opacity: 0, filter: 'blur(20px)' },
          { 
            opacity: 1, 
            filter: 'blur(0px)',
            stagger: { each: 0.05, from: 'random' },
            ease: 'power1.inOut',
            scrollTrigger: {
              trigger: title,
              start: 'top bottom',
              end: 'center center',
              toggleActions: 'play none none reset'
            }
          }
        );
      });

      // Effect 11
      fx11Titles.forEach(title => {
        const elements = getElementsToAnimate(title);
        const splitBy = title.getAttribute('data-split-by') || 'chars';
        
        if (splitBy === 'chars') {
          wrapElements(elements, 'span', 'char-wrap');
        }
        
        gsap.fromTo(elements,
          { xPercent: 105 },
          { 
            xPercent: 0,
            stagger: 0.042,
            ease: 'expo',
            scrollTrigger: {
              trigger: title,
              start: 'top bottom',
              end: 'top top+=10%',
              toggleActions: 'play none none reset'
            }
          }
        );
      });

      // Effect 12 - 3D Rotation
      fx12Titles.forEach(title => {
        const elements = getElementsToAnimate(title);
        elements.forEach(el => gsap.set(el.parentNode, { perspective: 1000 }));
        gsap.fromTo(elements,
          { 
            opacity: 0, 
            rotationX: -180, 
            rotationY: -90, 
            transformOrigin: '50% 50% -50'
          },
          { 
            opacity: 1, 
            rotationX: 0, 
            rotationY: 0,
            stagger: 0.06,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: title,
              start: 'top 80%',
              end: 'top 10%',
              scrub: true
            }
          }
        );
      });

      // Effect 13 - Letter Bounce
      fx13Titles.forEach(title => {
        const elements = getElementsToAnimate(title);
        gsap.fromTo(elements,
          { opacity: 0, y: 80 },
          { 
            opacity: 1,
            y: 0,
            stagger: 0.05,
            ease: 'bounce.out',
            duration: 1,
            scrollTrigger: {
              trigger: title,
              start: 'top 80%',
              toggleActions: 'play none none reset'
            }
          }
        );
      });

      // Effect 14 - Wave Effect
      fx14Titles.forEach(title => {
        const elements = getElementsToAnimate(title);
        gsap.fromTo(elements,
          { 
            opacity: 0, 
            y: (i) => Math.sin(i * 0.3) * 40
          },
          { 
            opacity: 1,
            y: 0,
            stagger: 0.04,
            ease: 'back.out(1.7)',
            scrollTrigger: {
              trigger: title,
              start: 'top 80%',
              end: 'top 10%',
              scrub: 1
            }
          }
        );
      });

      // Effect 15 - Glitch Effect
      fx15Titles.forEach(title => {
        const splitBy = title.getAttribute('data-split-by') || 'chars';
        
        if (splitBy === 'chars') {
          const chars = title.querySelectorAll('.char');
          const timeline = gsap.timeline({
            scrollTrigger: {
              trigger: title,
              start: 'top 80%',
              toggleActions: 'play none none reset'
            }
          });
          
          chars.forEach((char, i) => {
            const glitchDuration = 0.1;
            const delay = i * 0.05;
            
            timeline.fromTo(char, 
              { opacity: 0, x: -10, filter: 'blur(0px)' },
              { opacity: 1, x: 0, duration: 0.2, delay: delay }, 
              0
            );
            
            for (let j = 0; j < 3; j++) {
              const glitchTime = delay + 0.2 + j * 0.2;
              timeline.to(char, { 
                x: gsap.utils.random(-5, 5), 
                y: gsap.utils.random(-5, 5),
                filter: 'blur(2px)',
                opacity: 0.8,
                duration: glitchDuration 
              }, glitchTime);
              
              timeline.to(char, { 
                x: 0, 
                y: 0, 
                filter: 'blur(0px)',
                opacity: 1,
                duration: glitchDuration 
              }, glitchTime + glitchDuration);
            }
          });
        } else {
          // Fallback for words and lines - simple fade in with slight distortion
          const elements = getElementsToAnimate(title);
          gsap.fromTo(elements,
            { opacity: 0, x: -10 },
            { 
              opacity: 1,
              x: 0,
              stagger: 0.1,
              ease: 'power2.out',
              scrollTrigger: {
                trigger: title,
                start: 'top 80%',
                toggleActions: 'play none none reset'
              }
            }
          );
        }
      });
    };

    scroll();

    // Initialize Lenis
    const lenis = new Lenis({
      lerp: 0.2,
      smooth: true
    });

    ScrollTrigger.scrollerProxy(document.body, {
      scrollTop(value) {
        if (arguments.length) {
          lenis.scrollTo(value, { immediate: true });
        }
        return lenis.scroll.instance.scroll.y;
      },
      getBoundingClientRect() {
        return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
      },
      pinType: document.body.style.transform ? "transform" : "fixed"
    });

    lenis.on('scroll', ScrollTrigger.update);

    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    ScrollTrigger.refresh();
    
    // Handle Shopify section events for reinitialization
    document.addEventListener('shopify:section:load', function(event) {
      // Re-initialize Splitting for the newly loaded section
      const titles = event.target.querySelectorAll('[data-splitting]');
      if (titles.length > 0) {
        titles.forEach(title => {
          const splitBy = title.getAttribute('data-split-by') || 'chars';
          Splitting({ target: title, by: splitBy });
        });
        
        // Re-run scroll animations
        scroll();
        
        // Refresh ScrollTrigger
        ScrollTrigger.refresh();
      }
    });
  });
});